/*
 * Boopr custom JS. Activat din layout/theme.liquid (2026-09-29).
 * Auto-open-ul de cos la adaugare a fost incercat si RETRAS la
 * cererea lui Alex (prea intruziv, click in plus la inchidere).
 * Notificarea "in cos" = toast-ul nativ, rebranduit ca pastila
 * gold cu doggo (assets/boopr-ux.css + sections/api-product-popdown.liquid).
 */
(function () {
  var observer = null;
  var fallbackTimer = null;

  function chatWindowOpen() {
    var win = document.getElementById('rollo-win');
    if (!win) return false;
    var cs = getComputedStyle(win);
    return win.offsetParent !== null && cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.1;
  }

  function restoreRollo() {
    var rollo = document.getElementById('rollo');
    if (!rollo) return;
    rollo.style.opacity = '';
    rollo.style.pointerEvents = '';
  }

  /* Cand apare pastila "in cos", bula Rollo (launcher + nudge) dispare
     de tot: sta la z-index max si acoperea pastila, mai ales pe mobil.
     Revine cand pastila se inchide. Daca fereastra de chat e DESCHISA,
     nu ascundem nimic (nu-i taiem conversatia omului). */
  document.addEventListener('theme:cart:popdown', function () {
    var callout = document.getElementById('rollo-callout');
    if (callout) callout.classList.remove('show');

    var rollo = document.getElementById('rollo');
    if (!rollo || chatWindowOpen()) return;

    rollo.style.transition = 'opacity 0.25s ease';
    rollo.style.opacity = '0';
    rollo.style.pointerEvents = 'none';

    /* Restore precis: cand pastila pierde .is-visible (dupa fade). */
    var pill = document.querySelector('.product-add-popdown');
    if (observer) { observer.disconnect(); observer = null; }
    if (fallbackTimer) clearTimeout(fallbackTimer);
    if (pill) {
      observer = new MutationObserver(function () {
        if (!pill.classList.contains('is-visible')) {
          if (observer) { observer.disconnect(); observer = null; }
          setTimeout(restoreRollo, 350);
        }
      });
      observer.observe(pill, { attributes: true, attributeFilter: ['class'] });
    }
    /* Plasa de siguranta: daca pastila nu mai apare (fetch esuat etc.),
       bula revine oricum dupa 9s. */
    fallbackTimer = setTimeout(restoreRollo, 9000);
  });
})();
